/*eslint-disable react/no-danger*/

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import bbcode from 'bitter-bbcode';
import { emojify } from 'react-emojione';
import moment from 'moment';

import ResourceCommentsList from 'containers/ResourceCommentsList';
import ForumLiveCommentsList from './ForumLiveCommentsList';
import ResourceCommentsTextEditor from 'containers/ResourceCommentsTextEditor';
import { ForumThreadShape } from 'entities';
import { getForumThread } from 'selectors';
import * as actions from 'actions';
import { actionCausedByURLChangeFrom } from 'utils/actions';
import ForumThreadProfileSidebar from './ForumThreadProfileSidebar';
import UserAvatar from 'components/UserAvatar';
import { findCommentRepliesType } from 'commentsResourceTypes';
import { isLiveNow, isSoonToBeLive } from 'forumLiveStatus';
import './style.scss';

class ForumThreadProfile extends Component {

  constructor() {
    super();

    this.handleFollow = this.handleFollow.bind(this);
    this.handleUnfollow = this.handleUnfollow.bind(this);
    this.defaultForumThread = {};
  }

  componentDidMount() {
    this.props.onDidMount && this.props.onDidMount(this.props.forumThread);
  }

  componentDidUpdate(prevProps) {
    this.props.onDidUpdate && this.props.onDidUpdate(prevProps);
  }

  handleFollow() {
    this.props.onFollow && this.props.onFollow(this.props.forumThread);
  }

  handleUnfollow() {
    this.props.onUnfollow && this.props.onUnfollow(this.props.forumThread);
  }

  render() {
    const { forumThread } = this.props;

    return (
      <div className="ForumThreadProfile" ref="forumThreadProfile">
        <div className="wrapper-large is-collapsed">
          <div className="community-resource">
            {forumThread && <div className="head">
              <h1>{forumThread.title}</h1>

              <div className="forum-thread-meta">
                <UserAvatar letter={forumThread.author.userName[0]} imageUrl={forumThread.author.avatar.url} />

                <span className="author">
                  <strong>{forumThread.author.userName}</strong>
                </span>
                <span className="time">{moment(forumThread.createdAt).format(process.env.KOOTH_DATE_FORMAT)}</span>
              </div>
            </div>}

            {(() => {
              if(forumThread) {
                return <div className="resource-text-content" dangerouslySetInnerHTML={{__html: emojify(bbcode(forumThread.body), {output: 'unicode'})}} />;
              }

              return (
                <div className="while-loading">
                  <h3>{__('members.forum.loading')}</h3>
                </div>
              );
            })()}

            {forumThread &&
              <div className="resource-actions">
                <div className="resource-add-comment">
                  <ResourceCommentsTextEditor
                    ref="textEditor"
                    isForNewComments
                    resourceType="forumThreads"
                    resourceId={forumThread.id}
                  />
                </div>

                {(() => {
                  if(isLiveNow(forumThread) || isSoonToBeLive(forumThread)) {
                    return (
                      <ForumLiveCommentsList
                        forumThread={forumThread}
                        isFollowed={forumThread.followed}
                        onFollow={this.handleFollow}
                        onUnfollow={this.handleUnfollow}
                      />
                    );
                  }

                  return (
                    <ResourceCommentsList
                      scrollElementGetter={() => this.refs.forumThreadProfile}
                      urlParams={this.props.params}
                      isFollowed={forumThread.followed}
                      resourceId={forumThread.id}
                      canCommentsBeRepliedTo={!forumThread.live}
                      resourceType="forumThreads"
                      repliesResourceType={findCommentRepliesType('forumThreads')}
                      onFollow={this.handleFollow}
                      onUnfollow={this.handleUnfollow}
                    />
                  );
                })()}
              </div>
            }
          </div>

          <ForumThreadProfileSidebar isWider />
        </div>
      </div>
    );
  }
}

ForumThreadProfile.propTypes = {
  forumThread: ForumThreadShape,
  params: PropTypes.object,
  onDidMount: PropTypes.func,
  onDidUpdate: PropTypes.func,
  onFollow: PropTypes.func,
  onUnfollow: PropTypes.func
};

const mapStateToProps = (state, props) => {
	return {
    forumThread: getForumThread(state, props.params.id)
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onDidMount: forumThread => {
      if(!forumThread) {
        dispatch(actionCausedByURLChangeFrom(actions.forumThreadProfileFetch(props.params.id)));
      }
    },
    onDidUpdate: prevProps => {
      if(prevProps.params.id !== props.params.id) {
        dispatch(actionCausedByURLChangeFrom(actions.forumThreadProfileFetch(props.params.id)));
      }
    },
    onFollow: forumThread => {
      dispatch(actions.forumThreadUpdate(forumThread.id, forumThread, {followed: true}));
    },
    onUnfollow: forumThread => {
      dispatch(actions.forumThreadUpdate(forumThread.id, forumThread, {followed: false}));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumThreadProfile);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumThreadProfile/index.js
 **/